import createCache from "@emotion/cache";

/**
 * Emotion cache for MUI. `prepend: true` injects MUI's generated styles at
 * the TOP of <head>, so anything loaded later (during the Tailwind→MUI
 * transition that's still importing globals.css, and any per-component `sx`)
 * can override the base component styles by normal cascade order.
 *
 * Shared as a single module-level instance so the same cache is reused
 * everywhere, including inside the Tauri webview (no per-render cache churn).
 */
export const muiCache = createCache({ key: "mui", prepend: true });
